module.exports = __webpack_public_path__ + "img/slider-2-mobile.ad95f204.png";